frontApp.imagesSlider = {
  name: 'imagesSlider',
  description: 'images slider',
  sliderEl: '.js-images-slider',
  className: {
    buttonHide: 'buttons-is-hide',
  },
  image: '.js-images-slider-zoom',
  init() {
    const sliders = document.querySelectorAll(this.sliderEl);

    if (sliders) {
      for (let i = 0; i < sliders.length; i++) {
        const slider = new Splide(sliders[i], {
          autoWidth: true,
          perPage: 4,
          perMove: 1,
          mediaQuery: 'min',
          pagination: false,
          gap: '8px',
          breakpoints: {
            992: {
              perPage: 6,
              autoWidth: false,
              gap: '24px',
            },
            1600: {
              autoWidth: false,
              perPage: 7,
            },
          },
        });

        const toggleViewButtonsClass = (prev, next) => {
          const { arrows } = slider.Components.Elements;
          slider.root.classList.remove(this.className.buttonHide);
          arrows.style.display = '';
          if (prev.disabled && next.disabled) {
            slider.root.classList.add(this.className.buttonHide);
            setTimeout(() => {
              arrows.style.display = 'none';
            });
          }
        };

        slider.on('arrows:mounted', (prev, next) => {
          toggleViewButtonsClass(prev, next);
        });

        slider.on('arrows:updated', (prev, next) => {
          toggleViewButtonsClass(prev, next);
        });

        Fancybox.bind(this.image, {
          mainClass: 'image-zoom-theme',
          Toolbar: {
            display: [
              'zoom',
              'close',
            ],
          },
        });

        slider.mount(window.splide.Extensions);
      }
    }
  },
};
